import { ensureHeterotopicChiralBonds } from '../diastereotopic/ensureHeterotopicChiralBonds.js';
const MAX_NB_ATOMS = 250;
/**
 * Expand all the implicit hydrogens and ensure that the heterotopic bonds
 * @param molecule
 * @returns
 */
export function getMoleculeWithH(molecule) {
    const moleculeWithH = molecule.getCompactCopy();
    moleculeWithH.addImplicitHydrogens();
    if (moleculeWithH.getAllAtoms() > MAX_NB_ATOMS) {
        throw new Error(`Too many atoms to add hydrogens: ${moleculeWithH.getAllAtoms()} > ${MAX_NB_ATOMS}`);
    }
    ensureHeterotopicChiralBonds(moleculeWithH);
    return moleculeWithH;
}
//# sourceMappingURL=getMoleculeWithH.js.map